export const config = {
  apiLocation: process.env.API_LOCATION || '/',
  production: process.env.NODE_ENV === 'production',
  googleMapsApiKey: process.env.GOOGLE_MAPS_API_KEY,
  sentryPublicDsn: process.env.SENTRY_PUBLIC_DSN,

  // Consts
  PAYMENT_DETAILS: 'payment_details',

  PAYMENTS: {
    MIN_AMOUNT: {
      CENTS: 100,
      DOLLARS: 1
    },

    MAX_AMOUNT: {
      CENTS: 1500000,
      DOLLARS: 15000
    }
  }

};



// WEBPACK FOOTER //
// ./src/config.ts